import React, { Component } from 'react';
import Heading from '../elements/Heading';
import globals from "../globals";

class PanelList extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            list: []
        };
    }

	componentDidMount() {
		this.controller = globals.genericAnimation(this);
	}

	componentWillUnmount() {
		globals.destroy(this.controller);
	}

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState(this.props.data);
        }
    }
    
    render() {
        const LeadCopy = this.state.leadCopy.map((item, key) => {
            return (
                <p key={key} dangerouslySetInnerHTML={{__html: item}} />
            );
        });

        const List = this.state.list.map((item, key) => {
            return (
                <li key={key}>{item}</li>
            );
        });

        return (

            <div className="panel-list reverse">
                <div className="left">
                    <Heading title={this.state.title} subTitle={this.state.subTitle} />
                    {LeadCopy}
                </div>
                <div className="right">
                    <ul>
                        {List}
                    </ul>
                </div>
            </div>
        );
    }
    
}

export default PanelList;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/PanelList.js